module.exports = __webpack_public_path__ + "static/media/1.3f86d1f7.jpeg";